import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  listContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexGrow: 1
  },
  listContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexGrow: 1,
    borderBottom: "1px solid #eeeeee"
  },
  emptyDataHolder: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c3c3c3",
    fontSize: 14
  }
}));
